import useTranslate, { Trans } from './useTranslate';

export default useTranslate;
export { Trans };
